import React, { useState } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import ArticleGenerator from './components/ArticleGenerator';
import PostsList from './components/PostsList';
import PostEdit from './components/PostEdit';
import ErrorLogs from './components/ErrorLogs';
import PromptsList from './components/PromptsList';
import ReferencesList from './components/ReferencesList';
import PromptEdit from './components/PromptEdit';
import Refinador from './components/Refinador';
import { BarChart3, Sparkles, FileText, Settings, Bug, Lightbulb, BookMarked, Wand2 } from 'lucide-react';
import './App.css';

function App() {
    const [activeTab, setActiveTab] = useState('dashboard');
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const navigate = useNavigate();

    // Simple password gate (fixed password: imobi123)
    const [isAuthenticated, setIsAuthenticated] = useState(() => localStorage.getItem('APP_AUTH_OK') === 'true');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleSubmitPassword = (e) => {
        e.preventDefault();
        if (password === 'imobi123') {
            localStorage.setItem('APP_AUTH_OK', 'true');
            setIsAuthenticated(true);
        } else {
            setError('Senha incorreta');
        }
    };

    const handleArticleGenerated = () => {
        setRefreshTrigger(prev => prev + 1);
        // Após gerar, navegar para Meus Posts
        setActiveTab('posts');
        navigate('/posts');
    };

    const tabs = [
        { id: 'dashboard', label: 'Dashboard', icon: BarChart3, path: '/' },
        { id: 'generator', label: 'Gerar Artigo', icon: Sparkles, path: '/generator' },
        { id: 'refinador', label: 'Refinador', icon: Wand2, path: '/refinador' },
        { id: 'posts', label: 'Meus Posts', icon: FileText, path: '/posts' },
        { id: 'prompts', label: 'Prompts', icon: Lightbulb, path: '/prompts' },
        { id: 'references', label: 'Referências', icon: BookMarked, path: '/references' },
        { id: 'logs', label: 'Logs', icon: Bug, path: '/logs' },
        { id: 'settings', label: 'Configurações', icon: Settings, path: '/settings' }
    ];

    const handleNavClick = (tab) => {
        setActiveTab(tab.id);
        navigate(tab.path);
    };

    // Render password gate if not authenticated yet
    if (!isAuthenticated) {
        return (
            <div className="auth-gate" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#f7f9fc' }}>
                <form onSubmit={handleSubmitPassword} className="auth-card" style={{ background: '#fff', padding: '2rem', border: '1px solid #e1e8f0', borderRadius: '12px', boxShadow: '0 8px 24px rgba(0,0,0,0.08)', minWidth: '320px' }}>
                    <h2 style={{ marginBottom: '1rem' }}>🔒 Acesso Protegido</h2>
                    <p style={{ marginBottom: '1rem', color: '#6c757d' }}>Digite a senha para continuar</p>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Senha"
                        style={{ width: '100%', padding: '0.75rem', border: '1px solid #d0d7de', borderRadius: '8px', marginBottom: '0.75rem' }}
                        autoFocus
                    />
                    {error && <div style={{ color: '#dc3545', marginBottom: '0.75rem' }}>{error}</div>}
                    <button type="submit" style={{ width: '100%', padding: '0.75rem', background: '#0d6efd', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>Entrar</button>
                </form>
            </div>
        );
    }

    return (
        <div className="App">
            <header className="app-header">
                <div className="header-content">
                    <div className="logo">
                        <h1>🤖 BlogBot AI</h1>
                        <p>Automatizador de Blog Inteligente</p>
                    </div>
                    
                    <nav className="main-nav">
                        {tabs.map(tab => {
                            const IconComponent = tab.icon;
                            return (
                                <button
                                    key={tab.id}
                                    className={`nav-btn ${activeTab === tab.id ? 'active' : ''}`}
                                    onClick={() => handleNavClick(tab)}
                                >
                                    <IconComponent size={20} />
                                    <span>{tab.label}</span>
                                </button>
                            );
                        })}
                    </nav>
                </div>
            </header>

            <main className="main-content">
                <div className="content-container">
                    <Routes>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/generator" element={<ArticleGenerator onArticleGenerated={handleArticleGenerated} />} />
                        <Route path="/refinador" element={<Refinador />} />
                        <Route path="/posts" element={<PostsList refreshTrigger={refreshTrigger} />} />
                        <Route path="/posts/:id/edit" element={<PostEdit />} />
                        <Route path="/prompts" element={<PromptsList />} />
                        <Route path="/prompts/:id" element={<PromptEdit />} />
                        <Route path="/references" element={<ReferencesList />} />
                        <Route path="/logs" element={<ErrorLogs />} />
                        <Route path="/settings" element={<div className="settings-placeholder"><h2>⚙️ Configurações</h2><p>Área de configurações em desenvolvimento...</p></div>} />
                    </Routes>
                </div>
            </main>

            <footer className="app-footer">
                <p>Feito com ❤️ usando React + Node.js + OpenAI</p>
            </footer>
        </div>
    );
}

export default App;